import { cn } from '@/lib/utils';
import { LoaderCircle } from 'lucide-react';

interface ScreenPreloaderProps {
  activate: boolean;
}

const ScreenPreloader = ({ activate = true }: ScreenPreloaderProps) => {
  return (
    <div
      className={cn(
        'fixed left-0 top-0 bg-black/80 w-full h-full z-50 flex justify-center items-center',
        !activate && 'hidden',
      )}
    >
      <div className="relative w-20 h-20 rounded-full">
        <LoaderCircle className="animate-spin text-main" size={60} />
      </div>
    </div>
  );
};

export default ScreenPreloader;
